"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchAccountModal = void 0;
const react_1 = __importStar(require("react"));
const polaris_1 = require("@shopify/polaris");
const nice_modal_react_1 = __importStar(require("@ebay/nice-modal-react"));
const AccountContext_1 = require("contexts/AccountContext");
const context_1 = require("@/common/context");
const SearchBar_1 = __importDefault(require("components/Dashboard/SearchBar"));
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
const noSearch_webp_1 = __importDefault(require("assets/images/dashboard/noSearch.webp"));
const queryDefinitions_1 = require("queryDefinitions");
const usePaginatedSearch_1 = __importDefault(require("components/usePaginatedSearch"));
const tokenHeader_1 = require("tokenHeader");
const debounce_1 = __importDefault(require("lodash/debounce"));
const switch_account_modal_styles_1 = require("./switch-account-modal.styles");
exports.SwitchAccountModal = nice_modal_react_1.default.create(() => {
    const modalRef = (0, react_1.useRef)(null);
    const modal = (0, nice_modal_react_1.useModal)();
    const [accounts, setAccounts] = (0, react_1.useState)([]);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const { setAccount } = (0, AccountContext_1.useAccount)();
    const { currentUser } = (0, context_1.useCurrentUser)();
    const handleModalClose = (0, react_1.useCallback)(() => {
        modal.remove();
    }, []);
    function handleSelectAccount(newAccount) {
        setAccount(newAccount.node);
        handleModalClose();
    }
    function focusOnSearchInput() {
        const modalElement = modalRef.current;
        const searchInput = modalElement === null || modalElement === void 0 ? void 0 : modalElement.querySelector('input.search-bar');
        searchInput === null || searchInput === void 0 ? void 0 : searchInput.focus();
    }
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    const [getFirstPageAccounts, { data, fetchMore }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_ACCOUNTS, {
        variables: { first: 10 }
    });
    (0, react_1.useEffect)(() => {
        if (modal.visible) {
            focusOnSearchInput();
        }
    }, [modal.visible]);
    (0, react_1.useEffect)(() => {
        setAccounts(data ? data.accounts.edges : []);
        setHasMore(data && data.accounts.pageInfo.hasNextPage);
    }, [data]);
    (0, react_1.useEffect)(() => {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        getFirstPageAccounts({ variables: { first: 10 } });
    }, []);
    const { handleSearch: executeSearch, handleLoadNext } = (0, usePaginatedSearch_1.default)(fetchMore, 'accounts', data);
    const handleSearch = (0, react_1.useCallback)(
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    (0, debounce_1.default)((e) => executeSearch(e.target.value), 1000, true), [fetchMore]);
    const renderAccounts = (accountList) => {
        if (!accountList || accountList.length === 0) {
            return (react_1.default.createElement(switch_account_modal_styles_1.StyledMessageContainer, { height: '220px' },
                react_1.default.createElement(switch_account_modal_styles_1.StyledGraphic, { alt: 'document emerging from a filing cabinet', src: noSearch_webp_1.default }),
                react_1.default.createElement(switch_account_modal_styles_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, "No Accounts")));
        }
        const accountMap = accounts.map((account) => {
            return (react_1.default.createElement("li", { className: 'list-group-item', key: account.node.name + account.node.id },
                react_1.default.createElement("div", { className: 'row align-items-center' },
                    react_1.default.createElement("div", { className: 'col-auto' },
                        react_1.default.createElement(switch_account_modal_styles_1.StyledAvatar, null,
                            react_1.default.createElement(switch_account_modal_styles_1.StyledAvatarLetter, null, account.node.name.charAt(0).toUpperCase() || ''))),
                    react_1.default.createElement("div", { className: 'col ml-n2' },
                        react_1.default.createElement(polaris_1.Text, { as: 'h4', fontWeight: 'bold', variant: 'headingMd' }, account.node.name),
                        react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' }, account.node.primaryHostedDomain.token),
                        (currentUser === null || currentUser === void 0 ? void 0 : currentUser.admin) && (react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' }, atob(account.node.id)))),
                    react_1.default.createElement("div", { className: 'col-auto' },
                        react_1.default.createElement(polaris_1.Button, { id: account.node.name.replace(/\s/g, ''), onClick: () => handleSelectAccount(account) }, "Go")))));
        });
        return (react_1.default.createElement("ul", { className: 'list-group list-group-flush list my-n3' }, accountMap));
    };
    return (react_1.default.createElement(polaris_1.Modal, { onClose: handleModalClose, open: modal.visible, title: 'Choose an Account' },
        react_1.default.createElement(polaris_1.Modal.Section, null,
            react_1.default.createElement("div", { id: 'account-modal', ref: modalRef },
                react_1.default.createElement("div", { className: 'card-body' },
                    (currentUser === null || currentUser === void 0 ? void 0 : currentUser.admin) && (react_1.default.createElement("div", { className: 'mt-n4' },
                        react_1.default.createElement(SearchBar_1.default, { onSearch: handleSearch }))),
                    renderAccounts(accounts),
                    react_1.default.createElement(switch_account_modal_styles_1.StyledMargin, { top: '20px' }, hasMore ? (react_1.default.createElement(MalomoButton_1.MalomoButton, { onClick: handleLoadNext }, "Load More")) : null))))));
});
